// components/CarriageTable.tsx
import React from 'react';
import TableContainer from 'Common/TableContainer';
import LoadingCounter from 'Common/Components/LoadingCounterProps';
import PaginationTest from 'Common/Components/Paginationtest';
import { X } from 'lucide-react';

interface CarriageTableProps {
  data: any[];
  columns: any[];
  loading: boolean;
  error: string;
  currentPage: number;
  totalPages: number;
  selectedNumber: number;
  onPageChange: (page: number) => void;
  sortState: any;
  onResetSort: () => void;
}

const CarriageTable: React.FC<CarriageTableProps> = ({
  data,
  columns,
  loading,
  error,
  currentPage,
  totalPages,
  selectedNumber,
  onPageChange,
  sortState,
  onResetSort
}) => {
  const sortLabels: any = {
    loading_date: "تاریخ بار گیری",
    weight: "وزن بار",
  };
  return (
    <>
      {sortState.name && (
        <div className="gap-1 mb-2 items-center flex">
          <X
            size={16}
            className="text-red-600 cursor-pointer"
            onClick={onResetSort}
          />
          مرتب‌سازی بر اساس:{' '}
          {sortState.step === 2
            ? ` (تاریخ ایجاد)`
            : `${sortLabels[sortState.name]} ${
                sortState.order === 'asc' ? '(صعودی)' : '(نزولی)'
              }`}
        </div>
      )}

      {data && data.length > 0 ? (
        <TableContainer
          isPagination={false}
          columns={columns}
          isGlobalFilter={false}
          data={data}
          customnumberfortable={10}
          customPageSize={selectedNumber}
          divclassName="-mx-5 overflow-x-auto"
          tableclassName="w-full whitespace-nowrap "
          theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
          thclassName="px-3.5 py-2.5 dark:text-white first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
          tdclassName="px-3.5 py-2.5 first:pl-5  last:pr-5 border-y border-slate-200 dark:border-zink-500"
          PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
        />
      ) : (
        <LoadingCounter
          count={data ? 0 : 15}
          text={error ? error : 'داده ای در جدول وجود ندارد'}
        />
      )}

      <PaginationTest
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </>
  );
};

export default CarriageTable;

